var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.showButton),expression:"showButton"}],staticClass:"scroll-to-top",attrs:{"color":"#0B578B","fixed":"","fab":""},on:{"click":_vm.scrollToTop}},[_c('v-icon',{attrs:{"color":"white","size":"45"}},[_vm._v("mdi-chevron-up")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }